import { Controller } from "stimulus";
import MicroModal from "micromodal";
import { useDispatch } from "stimulus-use";
import { Cart } from "util/new_cart.js";

export default class extends Controller {
  static targets = [
    "modal",
    "guestsCount",
    "adultsCount",
    "childrenCount",
    "card"
  ];

  connect() {
    useDispatch(this);
  }

  showModal(event) {
    const modalEditButton = event.currentTarget;
    const currentModal = this.currentModal(modalEditButton);
    const children = this.childrenCountTargets.find(target =>
      currentModal.contains(target)
    );
    const adults = this.adultsCountTargets.find(target =>
      currentModal.contains(target)
    );

    MicroModal.show(currentModal.getAttribute("id"),{
      onClose: this.restoreInputsValues(children, adults),
      disableFocus: true
    })
  }

  restoreInputsValues(children, adults) {
    children.value = children.getAttribute("data-saved");
    adults.value = adults.getAttribute("data-saved");
  }

  updateGuests() {
    const content = this.element.closest(".content");
    if (content) {
      const is_insurance = content.classList.contains("insurance");
    }
    this.cardTargets.forEach(card => {
      const realCard = card.closest(".checkout-booking-summary-card");
      const cart = new Cart(false, realCard.dataset.cartId)

      const children = this.childrenCountTargets.find(target =>
        card.contains(target)
      );

      if (children !== undefined) {
        children.setAttribute("data-saved", children.value);
        const adults = this.adultsCountTargets.find(target =>
          card.contains(target)
        );
        adults.setAttribute("data-saved", adults.value);

        const guests = this.guestsCountTargets.filter(target =>
            card.contains(target)
        );
        guests.forEach(element => {
          element.textContent = `${adults.value} Adults, ${children.value} Children`;
        });

        if (realCard) {
          const dhis = this;
          cart.update_item(realCard.dataset.cartItemId,{
            adults: adults.value,
            children: children.value,
          }).then(() => {
            dhis.dispatch("guestsSaved", {
              adults: adults.value,
              children: children.value
            });
          });
        } else {
          this.dispatch("guestsSaved", {
            adults: adults.value,
            children: children.value
          });
        }
      }
    });
  }

  updateGuestsAndSave(event) {
    const modalSaveButton = event.currentTarget;

    this.updateGuests();
    const currentModal = this.currentModal(modalSaveButton);
    if (currentModal) {
      MicroModal.close(currentModal.getAttribute("id"));
    } else {
      console.error("Modal not found");
    }
  }

  currentModal(button) {
    let currentModal = null;

    this.modalTargets.every(modal => {
      const currentCard = this.cardTargets.find(target =>
        target.contains(button)
      );
      currentModal = this.modalTargets.find(target =>
        currentCard.contains(target)
      );
      if (currentModal) {
        return false;
      } else {
        return true;
      }
    });
    return currentModal;
  }

  closeModal() {
    const currentModal = this.modalTargets.find(target =>
      target.contains(event.currentTarget)
    );

    MicroModal.close(currentModal.getAttribute("id"));
  }
}
